@let loaded = selectors.finishedLoading | select:false;

<!-- Header & "Back" button -->
<div class="flex items-center gap-x-3 mb-7">
  <mx-icon-button icon="arrow_back" routeName="RELATED_ACCOUNTS" ariaLabel="Go Back"/>
  <span class="text-headline-large">Dependent Details</span>
</div>

<!-- Main Details Card -->
<mat-card mxHiddenUntilLoaded [reveal]="loaded">
  <mat-card-title class="pb-0">
    <div class="flex flex-row justify-between items-center">
      <p class="text-headline-medium">{{selectors.fullName | select}}</p>
      @if (selectors.hasBlocks | select) {
        <div class="flex flex-row gap-1 justify-end items-center text-error text-headline-small">
          <mat-icon class="mat-icon-size-6 shrink-0">error_outline</mat-icon>
          <p>Blocks on account</p>
        </div>
      }
    </div>
  </mat-card-title>
  <mat-card-content>
    <!-- Tabbed routes -->
    <px-router-tab-group tabbedRouteName="DEPENDENT_DETAILS" [minHeightRem]="31.25"/>
  </mat-card-content>
</mat-card>
